// Simple pub/sub for triggering the global exchange (redeem code) modal.
const listeners = new Set();

export function onExchangeRequired(callback) {
  if (typeof callback !== 'function') {
    return () => {};
  }
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function emitExchangeRequired() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error('Exchange modal listener error:', error);
    }
  });
}
